import React from "react"
import {
    Navigate,
    Outlet,
    useNavigate
} from "react-router-dom"

import { useAuth } from "hooks/useAuth"
import { privateRoutes, publicRoutes } from "router/routes"
import { isDefined } from "utils/validation"

export const isAnAuthorizedEntity = (entity, path) => {
    const entityRole = entity?.entity_data?.entity_permission?.role
    if (!isDefined(entityRole)) return false

    const currentPath = Object.values({ ...privateRoutes, ...publicRoutes }).find(access => access.path === path)
    if (!currentPath) return true

    return currentPath.entityRoles.includes(entityRole)
}

export const isAnAuthorizedUser = (user, path) => {
    const userRole = user?.permission
    if (!isDefined(userRole)) return false

    const currentPath = Object.values({ ...privateRoutes, ...publicRoutes }).find(access => access.path === path)
    if (!currentPath) return true

    return currentPath.userRoles.includes(userRole)
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
export const PrivateRoute = ({ location, component: Component, pageProps, ...rest }) => {
    const { isLoggedIn, user, entity } = useAuth()
    const authTimer = React.useRef()
	const navigate = useNavigate()

    React.useEffect(() => {
        if (!isLoggedIn) {
            // if the user is still not logged after 1000ms, redirect
            authTimer.current = setTimeout(() => {
                navigate(publicRoutes.login.path)
            }, 1000)
        }
        else {
            clearTimeout(authTimer.current)
        }
    }, [isLoggedIn, location, navigate])

    if (isLoggedIn) {
        if (isAnAuthorizedEntity(entity, rest.path) && isAnAuthorizedUser(user, rest.path)) {
            return <Outlet />
        } else {
            return <Navigate to={privateRoutes.notAuthorized.path} />
        }
    }

    return (
        <div className="u-sticky-view">
            <div className="c-main-content flex justify-center items-center">
                <div className="c-spinner"></div>
            </div>
        </div>

    )
}